import { useState } from "react";
import * as api from "../../api";

/* P4A (F3) — Gestión de bancos/métodos de pago del Admin. Movido VERBATIM de App.js.
   `paymentMethods`/`setPaymentMethods` permanecen en App.js (estado compartido con
   checkout/usePaymentSubmit y loadPublicData) y se inyectan como dependencias. */
export function useAdminBanks({ paymentMethods, setPaymentMethods, showToast }) {
  const [showAddBankModal, setShowAddBankModal] = useState(false);
  const [editingPm, setEditingPm] = useState(null); // full PM object when editing
  const EMPTY_BANK_FORM = {
    type: "PAGO_MOVIL",
    active: true,
    bankName: "", bankCode: "",
    accountNumber: "", accountHolder: "", documentId: "", phone: "",
    platformName: "", accountIdentifier: "",
  };
  const [bankForm, setBankForm] = useState(EMPTY_BANK_FORM);

  const handleAddBank = async (e) => {
    e.preventDefault();
    const t = bankForm.type;
    // Client-side validation mirrors the backend rules for a snappier UX.
    if (t === "PAGO_MOVIL") {
      const need = ["bankName", "bankCode", "accountHolder", "documentId", "phone"];
      if (need.some(k => !(bankForm[k] || "").trim())) {
        showToast("Faltan datos", "Completa todos los campos de Pago Móvil", "error"); return;
      }
    } else if (t === "TRANSFERENCIA") {
      const need = ["bankName", "accountHolder", "documentId", "accountNumber"];
      if (need.some(k => !(bankForm[k] || "").trim())) {
        showToast("Faltan datos", "Completa todos los campos de Transferencia", "error"); return;
      }
      const digits = (bankForm.accountNumber || "").replace(/\D/g, "");
      if (digits.length !== 20) {
        showToast("Cuenta inválida", "El Nro. de Cuenta debe tener 20 dígitos", "error"); return;
      }
    } else if (t === "USD_PLATFORM") {
      const need = ["platformName", "accountIdentifier"];
      if (need.some(k => !(bankForm[k] || "").trim())) {
        showToast("Faltan datos", "Completa plataforma y correo/ID", "error"); return;
      }
    }
    try {
      if (editingPm) {
        const updated = await api.editPaymentMethod(editingPm.id, bankForm);
        setPaymentMethods(paymentMethods?.map(pm => pm.id === updated.id ? updated : pm));
        showToast("Cuenta Actualizada", "Cambios guardados", "success");
      } else {
        const newPm = await api.addPaymentMethod(bankForm);
        setPaymentMethods([...paymentMethods, newPm]);
        showToast("Cuenta Agregada", "Nuevo método de pago disponible", "success");
      }
      setShowAddBankModal(false);
      setEditingPm(null);
      setBankForm(EMPTY_BANK_FORM);
    } catch (err) {
      showToast("Error", err.message, "error");
    }
  };

  const handleDeleteBank = async (id) => {
    if (!window.confirm("¿Eliminar esta cuenta/método de pago?")) return;
    try {
      await api.deletePaymentMethod(id);
      setPaymentMethods(paymentMethods?.filter(pm => pm.id !== id));
      showToast("Eliminado", "Método removido", "success");
    } catch (err) {
      showToast("Error", err.message, "error");
    }
  };

  const handleTogglePmActive = async (pm) => {
    try {
      const updated = await api.togglePaymentMethodActive(pm.id, !pm.active);
      setPaymentMethods(paymentMethods?.map(p => p.id === updated.id ? updated : p));
      showToast(updated.active ? "Activado" : "Desactivado", "Estado del método actualizado", "success");
    } catch (err) {
      showToast("Error", err.message, "error");
    }
  };

  const openEditPm = (pm) => {
    setEditingPm(pm);
    setBankForm({
      type: pm.type || "PAGO_MOVIL",
      active: pm.active !== false,
      bankName: pm.bankName || "",
      bankCode: pm.bankCode || "",
      accountNumber: pm.accountNumber || "",
      accountHolder: pm.accountHolder || "",
      documentId: pm.documentId || "",
      phone: pm.phone || "",
      platformName: pm.platformName || "",
      accountIdentifier: pm.accountIdentifier || "",
    });
    setShowAddBankModal(true);
  };

  return {
    showAddBankModal, setShowAddBankModal,
    editingPm, setEditingPm,
    EMPTY_BANK_FORM, bankForm, setBankForm,
    handleAddBank, handleDeleteBank, handleTogglePmActive, openEditPm,
  };
}
